export interface IntelEventMaterialityConfig {
  // Minimum per-event relevance score to include (0-1).
  minRelevance: number;
  // Max events we keep per day in grid/intel surfaces.
  maxPerDay: number;
  // How many events to show by default (with "show more" to expand).
  showTopN: number;
}

const DEFAULT_CONFIG: IntelEventMaterialityConfig = {
  minRelevance: 0.5,
  maxPerDay: 8,
  showTopN: 3,
};

// Optional per-property overrides (slugs).
const PER_PROPERTY: Record<string, Partial<IntelEventMaterialityConfig>> = {};

export function getIntelEventsConfig(propertySlug: string | null | undefined) {
  const key = String(propertySlug || '').toLowerCase();
  return { ...DEFAULT_CONFIG, ...(PER_PROPERTY[key] ?? {}) };
}
